
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"nonzero","d":"M13 12.67l1.44-1.45a.5.5 0 01.71 0l.7.71a.5.5 0 010 .71l-3.13 3.14a.751.751 0 01-.53.22h-.38a.77.77 0 01-.53-.22l-3.13-3.13a.5.5 0 010-.71l.71-.71a.49.49 0 01.7 0L11 12.67V4a1 1 0 011-1h7a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2v16h14V5h-6.001L13 12.67z","opacity":".8"}})])
          )
        }
      }
    